
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "nodejs-community-resources"
    }}>{`NodeJS Community Resources`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://stackoverflow.com/questions/tagged/node.js"
        }}>{`Stackoverflow`}</a>{` - Stackoverflow NodeJS Tag`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://hackr.io/tutorials/learn-node-js"
        }}>{`Hackr.io`}</a>{` - Community Curated`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nodejs/node/issues"
        }}>{`Github Issues list`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://webchat.freenode.net/?channels=node.js"
        }}>{`freenode's WebChat`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://newsletter.nodejs.org/"
        }}>{`NodeJS Everywhere`}</a>{` - The official Node.js Weekly Newsletter.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nodeup.com/"
        }}>{`NodeUp`}</a>{` - A podcast covering the latest Node news in the community.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://gitter.im/nodejs/node"
        }}>{`NodeJS Gitter`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://discord.gg/96WGtJt"
        }}>{`NodeJS Discord`}</a>{` - The 🔮 Magic NodeJS Discord Server`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;